import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  computed,
  withDefaults,
  onBeforeUnmount,
} from "vue";
import { Message } from "element-ui";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    value: null,
    placeholder: null,
    size: null,
    emptyTips: null,
    disabled: { type: Boolean, default: false }
  },
  emits: ["send", "input"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
  (event: "send"): void;
  (event: "input", val: string | number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string | number, placeholder?: string, size?: "medium" | "small" | "mini", emptyTips?: string, disabled: boolean }





// 倒计时时间，为0的时候才可以点击
const countNum = ref<number>(0);
// 倒计时超时
let countDownTimeout: any = null;

// 当前是否可以点击发送验证码
const computedCouldSend = computed<boolean>(() => {
  return countNum.value === 0;
});

// 按钮文字
const computedBtnText = computed<string>(() => {
  return computedCouldSend.value
    ? "获取验证码"
    : `${countNum.value} 秒后重新获取`;
});

// 倒计时减少
function execCountNum() {
  countDownTimeout = setTimeout(() => {
    if (countNum.value > 0) {
      countNum.value--;
      execCountNum();
    } else {
      countNum.value = 0;
    }
  }, 1000);
}

// 输入内容
function onInput(e) {
  emits("input", e);
}

// 用户点击发送
function onSendBtnClick() {
  if (props.emptyTips && props.value === "") {
    return Message.warning(props.emptyTips);
  }
  emits("send");
  countNum.value = 60;
  execCountNum();
}

// 重置
function reset() {
  clearTimeout(countDownTimeout);
  countNum.value = 0;
}

expose({
  reset,
});

// 生命周期
onBeforeUnmount(() => {
  clearTimeout(countDownTimeout);
});

return { __sfc: true,emits, props, countNum, countDownTimeout, computedCouldSend, computedBtnText, execCountNum, onInput, onSendBtnClick, reset }
}

})